import React, { useEffect, useState } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { hot } from 'react-hot-loader/root';
import { Provider, useSelector } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import store from './redux/store';
import Admin from './routes/admin';
import Auth from './routes/auth';
import './static/css/style.css';
import config from './config/config';
import ProtectedRoute from './components/utilities/protectedRoute';
import Login from './container/profile/authentication/overview/SignIn';
import SignUp from './container/profile/authentication/overview/SignUp';
import ForgotPassword from './container/profile/authentication/overview/ForgotPassword';
import resetPassword from './container/profile/authentication/overview/resetPassword';
import AuthLayout from './container/profile/authentication/Index';
import EmailVerification from './container/profile/authentication/overview/EmailVerification';
import NotFound from './routes/admin/NotFound';

const { theme } = config;

const ProviderConfig = () => {
  const { rtl, isLoggedIn, topMenu, darkMode } = useSelector(state => {
    return {
      darkMode: state.ChangeLayoutMode.data,
      rtl: state.ChangeLayoutMode.rtlData,
      topMenu: state.ChangeLayoutMode.topMenu,
      isLoggedIn: state.auth.token,
    };
  });

  const [path, setPath] = useState(window.location.pathname);

  useEffect(() => {
    let unmounted = false;
    if (!unmounted) {
      setPath(window.location.pathname);
    }
    // eslint-disable-next-line no-return-assign
    return () => (unmounted = true);
  }, [setPath]);
  return (
    <ConfigProvider direction={rtl ? 'rtl' : 'ltr'}>
      <ThemeProvider theme={{ ...theme, rtl, topMenu, darkMode }}>
        <Router basename={process.env.PUBLIC_URL}>
          <Switch>
            <Route exact path="/login" component={AuthLayout(Login)} />
            <Route exact path="/register" component={AuthLayout(SignUp)} />
            <Route exact path="/forgot-password" component={AuthLayout(ForgotPassword)} />
            <Route exact path="/password/reset/:token" component={AuthLayout(resetPassword)} />
            <Route exact path="/email-verify/:token" component={AuthLayout(EmailVerification)} />
            <ProtectedRoute path="/" component={Admin} />
            <Route exact path="*" component={NotFound} />
          </Switch>
          {isLoggedIn && (path === process.env.PUBLIC_URL || path === `${process.env.PUBLIC_URL}/`) && (
            <Redirect to="/" />
          )}
        </Router>
      </ThemeProvider>
    </ConfigProvider>
  );
};

function App() {
  return (
    <Provider store={store}>
      <ProviderConfig />
    </Provider>
  );
}

export default hot(App);
